// extracted by mini-css-extract-plugin
export var bodyRow = "_f3-d";
export var cardColumns = "_f3-e";
export var ellipsesOverflow = "_f3-2";
export var flatBottomCorners = "_f3-3";
export var flatTopCorners = "_f3-4";
export var headerActionsDropdown = "_f3-f";
export var headerBottomRow = "_f3-c";
export var headerTopRow = "_f3-b";
export var orderDetailsWrapper = "_f3-0";
export var orderInfoContainer = "_f3-1";
export var productDetails = "_f3-9";
export var productImage = "_f3-5";
export var responsiveTable = "_f3-8";
export var shipmentContainer = "_f3-a";
export var tableBottomLeft = "_f3-6";
export var tableBottomRight = "_f3-7";
export var trackingLink = "_f3-g";